import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FactoryAddressService {
  private readonly http = inject(HttpClient);
  private readonly endPoint = environment.API_ENDPOINT + 'factory-addresses/';
  getAllWithFilters(options?: { factory?: string }): Observable<any> {
    if (!options?.factory) {
      return of({ data: [] });
    }

    return this.http.get(`${this.endPoint}?factoryId=${options.factory}`);
  }
  getById(id: string): Observable<any> {
    return this.http.get(this.endPoint + id);
  }
  create(payload: any): Observable<any> {
    return this.http.post(this.endPoint, payload);
  }
  update(id: string, payload: any): Observable<any> {
    return this.http.patch(this.endPoint + id, payload);
  }
  delete(id: string): Observable<any> {
    return this.http.delete(this.endPoint + id);
  }
  makeMainAddress(id: string, factory: string): Observable<any> {
    return this.http.patch(`${this.endPoint}make-main-address/${id}?factory=${factory}`, {});
  }
  getGroupOfFactoryAddress(id: string): Observable<any> {
    return this.http.get(this.endPoint + 'group-of-factory/' + id);
  }
}
